import { render, staticRenderFns } from "./QuestionButtons.vue?vue&type=template&id=15691b54&scoped=true&"
import script from "./QuestionButtons.vue?vue&type=script&lang=ts&"
export * from "./QuestionButtons.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionButtons.vue?vue&type=style&index=0&id=15691b54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15691b54",
  null
  
)

export default component.exports